import { path } from 'ramda';

import { FEATURE_NAME as $, PARAMS } from './consts';

export const getAnalyticsParams = path([$, PARAMS]);
